import React from 'react';
import RoleBasedDashboard from '../components/RoleBasedDashboard';

export const DashboardPage: React.FC = () => {
  return <RoleBasedDashboard />;
};
